import React from "react";

 export default function AppStore() {
    return(
        <>
        <p>App Store Page</p>
        </>
    );
 }
